

// import React, { useState } from 'react';
// import { Menu, X } from 'lucide-react';
// import { useLocation } from 'react-router-dom';

// const Header = () => {
//   const [isMenuOpen, setIsMenuOpen] = useState(false);
//   const location = useLocation();
//   const isClientPage = location.pathname === '/client';
  
//   const logoSrc = 'logo_b_w.png';
  
//   // Base menu items for the coach page
//   const coachMenuItems = [
//     { title: 'Features', href: '#features' },
//     { title: 'Why KinOS', href: '#why-different' },
//     { title: 'Solutions', href: '#solutions' },
//     { title: 'Testimonials', href: '#testimonials' },
//     { title: 'Client App', href: '/client' }
//   ];
  
//   // Menu items for the client page
//   const clientMenuItems = [
//     { title: 'For Coaches', href: '/' }, // Link back to the coach landing page
//     // Add other client page menu items here
//   ];
  
//   // Choose the appropriate menu items based on the current page
//   const menuItems = isClientPage ? clientMenuItems : coachMenuItems;

//   return (
//     <header className="border-b border-gray-100 sticky top-0 bg-white/80 backdrop-blur-md z-50">
//       <div className="max-w-7xl mx-auto">
//         <div className="flex items-center justify-between h-16 px-4 sm:px-6 md:px-8">
//           <div className="flex items-center flex-shrink-0">
//             <a href="/" className="flex items-center">
//               <div className={location.pathname !== '/' ? "bg-gray-100 rounded-md p-1" : "rounded-md overflow-hidden"}>
//                 <img
//                   src={logoSrc}
//                   alt="KinOS"
//                   className="h-12 w-12 object-contain rounded-md"
//                   style={location.pathname !== '/' ? { filter: 'drop-shadow(0 0 0 transparent)' } : {}}
//                 />
//               </div>
//               <span className="ml-3 text-2xl font-bold text-gray-800">KinOS</span>
//               {location.pathname === '/' && (
//                 <span className="ml-2 bg-emerald-500 text-white text-sm px-2 py-1 rounded-md">beta</span>
//               )}
//             </a>
//           </div>

//           {/* Mobile menu button */}
//           <div className="md:hidden">
//             <button
//               onClick={() => setIsMenuOpen(!isMenuOpen)}
//               className="p-2 rounded-md text-gray-600 hover:text-gray-900 hover:bg-gray-100"
//             >
//               {isMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
//             </button>
//           </div>

//           {/* Desktop Navigation */}
//           <nav className="hidden md:flex items-center justify-center flex-1">
//             <div className="flex space-x-8">
//               {menuItems.map((item, index) => (
//                 <a 
//                   key={index} 
//                   href={item.href} 
//                   className="text-base font-medium text-gray-700 hover:text-emerald-600 transition-colors relative group"
//                 >
//                   {item.title}
//                   <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-emerald-500 group-hover:w-full transition-all duration-300" />
//                 </a>
//               ))}
//             </div>
//           </nav>
         
//           <div className="hidden md:flex items-center">
//             <a 
//               href={location.pathname === '/' 
//                 ? "https://calendly.com/hyphii"
//                 : "https://apps.apple.com/us/app/hyphii-healthy-lifestyle-app/id6737209270"
//               }
//               target={location.pathname === '/' ? "_blank" : "_self"}
//               rel={location.pathname === '/' ? "noopener noreferrer" : ""}
//               className="hover:opacity-90 transition-opacity duration-300"
//             >
//               <button 
//                 className="w-full sm:w-auto bg-black text-white text-base px-6 py-3 rounded-xl hover:bg-emerald-600 transition duration-300 shadow-lg hover:shadow-xl"
//               >
//                {location.pathname !== '/' ? 'Download' : 'Schedule Demo'}
//               </button>
//             </a>
//           </div>
//         </div>

//         {/* Mobile menu */}
//         {isMenuOpen && (
//           <div className="md:hidden">
//             <div className="px-2 pt-2 pb-3 space-y-3">
//               {menuItems.map((item, index) => (
//                 <a 
//                   key={index} 
//                   href={item.href} 
//                   className="block px-6 py-2 rounded-md text-base font-medium text-gray-700 hover:text-emerald-600 hover:bg-gray-50 text-center"
//                   onClick={() => setIsMenuOpen(false)}
//                 >
//                   {item.title}
//                 </a>
//               ))}
              
//               <div className="pt-2">
//                 <a 
//                   href={location.pathname === '/' 
//                     ? "https://calendly.com/hyphii"
//                     : "https://apps.apple.com/us/app/hyphii-healthy-lifestyle-app/id6737209270"
//                   }
//                   target={location.pathname === '/' ? "_blank" : "_self"}
//                   rel={location.pathname === '/' ? "noopener noreferrer" : ""}
//                   className="block w-full"
//                 >
//                   <button 
//                     className="w-full bg-black text-white text-base px-6 py-3 rounded-xl hover:bg-emerald-600 transition duration-300 shadow-lg hover:shadow-xl"
//                   >
//                    {location.pathname !== '/' ? 'Download' : 'Schedule Demo'}
//                   </button>
//                 </a>
//               </div>
//             </div>
//           </div>
//         )}
//       </div>
//     </header>
//   );
// };

// export default Header;

import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';
import { useLocation } from 'react-router-dom';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();
  const isClientPage = location.pathname === '/client';
  
  const logoSrc = 'logo_b_w.png';
  
  // Base menu items for the coach page
  const coachMenuItems = [
    { title: 'Features', href: '#features' },
    { title: 'Why KinOS', href: '#why-different' },
    { title: 'Testimonials', href: '#testimonials' },
    { title: 'Client App', href: '/client' }
  ];
  
  // Menu items for the client page
  const clientMenuItems = [
    { title: 'For Coaches', href: '/' }, // Link back to the coach landing page
    { title: 'Highlights', href: '#highlights' },
    { title: 'Testimonials', href: '#testimonials' }
  ];
  
  // Choose the appropriate menu items based on the current page
  const menuItems = isClientPage ? clientMenuItems : coachMenuItems;

  return (
    <header className="border-b border-gray-100 sticky top-0 bg-white/80 backdrop-blur-md z-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between h-16 px-4 sm:px-6 md:px-8">
          <div className="flex items-center flex-shrink-0">
            <a href="/" className="flex items-center">
              <div className={location.pathname !== '/' ? "bg-gray-100 rounded-md p-1" : "rounded-md overflow-hidden"}>
                <img
                  src={logoSrc}
                  alt="KinOS"
                  className="h-12 w-12 object-contain rounded-md"
                  style={location.pathname !== '/' ? { filter: 'drop-shadow(0 0 0 transparent)' } : {}}
                />
              </div>
              <span className="ml-3 text-2xl font-bold text-gray-800">KinOS</span>
              {location.pathname === '/' && (
                <span className="ml-2 bg-emerald-500 text-white text-sm px-2 py-1 rounded-md">beta</span>
              )}
            </a>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden">
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="p-2 rounded-md text-gray-600 hover:text-gray-900 hover:bg-gray-100"
            >
              {isMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
            </button>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center justify-center flex-1">
            <div className="flex space-x-8">
              {menuItems.map((item, index) => (
                <a 
                  key={index} 
                  href={item.href} 
                  className="text-base font-medium text-gray-700 hover:text-emerald-600 transition-colors relative group"
                >
                  {item.title}
                  <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-emerald-500 group-hover:w-full transition-all duration-300" />
                </a>
              ))}
            </div>
          </nav>
         
          <div className="hidden md:flex items-center">
            <a 
              href={location.pathname === '/' 
                ? "https://calendly.com/hyphii"
                : "https://apps.apple.com/us/app/hyphii-healthy-lifestyle-app/id6737209270"
              }
              target={location.pathname === '/' ? "_blank" : "_self"}
              rel={location.pathname === '/' ? "noopener noreferrer" : ""}
              className="hover:opacity-90 transition-opacity duration-300"
            >
              <button 
                className="w-full sm:w-auto bg-black text-white text-base px-6 py-3 rounded-xl hover:bg-emerald-600 transition duration-300 shadow-lg hover:shadow-xl"
              >
               {location.pathname !== '/' ? 'Download' : 'Schedule Demo'}
              </button>
            </a>
          </div>
        </div>

        {/* Mobile menu */}
        {isMenuOpen && (
          <div className="md:hidden">
            <div className="px-2 pt-2 pb-3 space-y-3">
              {menuItems.map((item, index) => (
                <a 
                  key={index} 
                  href={item.href} 
                  className="block px-6 py-2 rounded-md text-base font-medium text-gray-700 hover:text-emerald-600 hover:bg-gray-50 text-center"
                  onClick={() => setIsMenuOpen(false)}
                >
                  {item.title}
                </a>
              ))}
              
              <div className="pt-2">
                <a 
                  href={location.pathname === '/' 
                    ? "https://calendly.com/hyphii"
                    : "https://apps.apple.com/us/app/hyphii-healthy-lifestyle-app/id6737209270"
                  }
                  target={location.pathname === '/' ? "_blank" : "_self"}
                  rel={location.pathname === '/' ? "noopener noreferrer" : ""}
                  className="block w-full"
                >
                  <button 
                    className="w-full bg-black text-white text-base px-6 py-3 rounded-xl hover:bg-emerald-600 transition duration-300 shadow-lg hover:shadow-xl"
                  >
                   {location.pathname !== '/' ? 'Download' : 'Schedule Demo'}
                  </button>
                </a>
              </div>
            </div>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;